
const routes = [



  {
    path: '/generalregistroscumplimiento',
    name: 'generalregistroscumplimiento',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Admin/GeneralRegistrosCumplimientoSistema.vue')
  },
  {
    path: '/dashboardcumplimiento',
    name: 'dashboardcumplimiento',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Admin/DashBoardCumplimientoSistema.vue')
  },
  {
    path: '/listempresas',
    name: 'listempresas',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Configuracion/ListEmpresasSistema.vue')
  },
  
];

export default routes.map(route => {
  return { ...route, meta: { public: false, admin:false, adminSagrilaft:false, adminCumplimiento:true, tercero:false } }
})